import StringConstants from 'app/shared/constants/StringConstants';
import AdproductsConstants from 'app/shared/constants/AdproductsConstants';

const { ProductTypes } = AdproductsConstants;

const parseFeedName = (feedName) => {
    const lowercaseFeedName = feedName.toLowerCase();
    return StringConstants.UNFORMATTED_BRAND_NAMES[lowercaseFeedName] ? 'Zillow Rental Manager' : feedName;
};

const parseProductTypes = (productTypes) => {
    const set = new Set(productTypes.map(productType => ProductTypes[productType]));
    return [...set];
};

const Property = ({
    aliasEncoded = 0,
    feedId = '',
    feedName = '',
    isFeed = '',
    active = false,
    address = {},
    isMultifamily = false,
    name = '',
    panels = [],
    photoUrl = '',
    status = {},
    productTypes = [],
    hasBoost = false,
} = {}) => ({
    aliasEncoded: String(aliasEncoded),
    feedId: String(feedId),
    feedName: parseFeedName(feedName),
    isFeed: Boolean(isFeed),
    active: Boolean(active),
    address: Object(address),
    isMultifamily: Boolean(isMultifamily),
    name: String(name),
    panels: panels.map(item => item),
    photoUrl: String(photoUrl),
    status: Object(status),
    productTypes: parseProductTypes(productTypes),
    hasBoost: Boolean(hasBoost),
});

export default Property;
